import { createBrowserRouter } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import App from '../app';
import Vehicles from '../pages/UserVehicles';
import Drivers from '../pages/Drivers';
import DriversForm from '../pages/Drivers/DriversForm';
import Dashboard from '../pages/Dashboard';
import Orders from '../pages/Orders';
import UserVehicleDetails from '../pages/UserVehicles/UserVehicleDetails';
import VehicleForm from '../pages/UserVehicles/VehicleForm';
import DebtsListing from '../pages/Debts';
import VehicleDetails from '../pages/UserVehicles/UserVehicleDetails/VehicleDetails';
import CreditPayment from '../pages/CreditPayment';
import PixPayment from '../pages/PixPayment';
import Proof from '../pages/Proof';
import LoginAws from '../pages/LoginAws';
import Users from '../pages/Users';
import UsersForm from '../pages/Users/UsersForm';
import PaymentInBatches from '../pages/PaymentInBatches';
import ExportsListing from '../pages/Exports';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginAws />,
  },
  {
    path: '/',
    element: <App />,
    errorElement: <NotFound />,
    children: [
      {
        path: '/',
        element: <Vehicles />,
      },
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/vehicles',
        element: <Vehicles />,
      },
      {
        path: '/vehicles/details',
        element: <UserVehicleDetails />,
      },
      {
        path: '/vehicles/details/payments',
        element: <VehicleDetails />,
      },
      {
        path: '/drivers',
        element: <Drivers />,
      },
      {
        path: '/drivers/create',
        element: <DriversForm />,
      },
      {
        path: '/drivers/edit/:id',
        element: <DriversForm />,
      },
      {
        path: '/users',
        element: <Users />,
      },
      {
        path: '/users/create',
        element: <UsersForm />,
      },
      {
        path: '/users/edit/:id',
        element: <UsersForm />,
      },
      {
        path: '/orders',
        element: <Orders />,
      },
      {
        path: '/users',
        element: <Users />,
      },
      {
        path: '/users/create',
        element: <UsersForm />,
      },
      {
        path: '/users/edit/:id',
        element: <UsersForm />,
      },
      {
        path: '/vehicles/register',
        element: <VehicleForm />,
      },
      {
        path: '/debts',
        element: <DebtsListing />,
      },
      {
        path: '/debts/payment',
        element: <PaymentInBatches />,
      },
      {    
        path: '/exports',
        element: <ExportsListing />,
      },
      {
        path: '/debts/credit-payment',
        element: <CreditPayment />,
      },
      {
        path: '/debts/pix',
        element: <PixPayment />,
      },
      {
        path: '/proof',
        element: <Proof />,
      },
    ],
  },
]);

export default router;
